import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { ProfileInfoForm } from "../components/ProfileInfoForm/ProfileInfoForm";

export const ProfileInfo = () => {
  return (
    <Fragment>
      <Row>
        <Col>
          <PageWrapper title="Documentación">
            <ProfileInfoForm />
          </PageWrapper>
        </Col>
      </Row>
    </Fragment>
  );
};
